import { CALL_API } from './api.middleware';
import jwt_decode from 'jwt-decode';
import { AFFILIATE_SERVICE_URL } from '../constants/api';
import {
  ActionTypes
} from "clorian-frontend-components";

const AUTH_URL = process.env.REACT_APP_API_AUTH;
const USER_SERVICE_URL = process.env.REACT_APP_USER_SERVICE_URL;
const CATALOG_SERVICE_URL = process.env.REACT_APP_CATALOG_SERVICE_URL;
const CLIENT_OAUTH = process.env.REACT_APP_CLIENT_OAUTH;
const CLIENT_SECRET_OAUTH = process.env.REACT_APP_CLIENT_SECRET_OAUTH;
const CLIENT_USER = process.env.REACT_APP_CLIENT_USER;
const CLIENT_PASS = process.env.REACT_APP_CLIENT_PASS;
const UTILS_SERVICE_URL = process.env.REACT_APP_UTILS_SERVICE_URL;
const clientAuthBase64 = btoa(`${CLIENT_OAUTH}:${CLIENT_SECRET_OAUTH}`);

const { LANGUAGE_FAILURE, LANGUAGE_REQUEST, LANGUAGE_SUCCESS } = ActionTypes;

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

function requestLogin(creds) {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    creds
  };
}

function receiveLogin(user) {
  return {
    type: LOGIN_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    // id_token: user.id_token
    id_token: user.jti
  };
}

function loginError(error) {
  const message = typeof error === 'string' ? error : error && error.message;
  const errorCode = typeof error === 'string' ? undefined : error && error.errorCode;
  return {
    type: LOGIN_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    message,
    errorCode
  };
}

export function loginVerifierUser(creds) {
  creds = {
    username: (creds && creds.username) || CLIENT_USER,
    password: (creds && creds.password) || CLIENT_PASS
  };

  let config = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      grant_type: 'password',
      username: creds.username,
      password: creds.password,
      module: 'affiliate'
    })
  };

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestLogin(creds));

    return fetch(`${USER_SERVICE_URL}/api/oauth/loginModule`, config)
      .then(response => response.json().then(user => ({ user, response })))
      .then(({ user, response }) => {
        if (!response.ok) {
          return dispatch(
            loginError({
              message: user.message || user.error_description,
              errorCode: user.errorCode
            })
          );
        } else {
          // If login was successful, set the token in local storage
          localStorage.setItem('id_token', user.jti);
          localStorage.setItem('access_token', user.access_token);
          if (user.refresh_token) {
            localStorage.setItem('refresh_token', user.refresh_token);
          }

          //change this when microservice has changed
          localStorage.setItem('id_pos', user.posAllowed[0]);
          localStorage.setItem('posAllowed', user.posAllowed);

          const decoded = jwt_decode(user.access_token);
          sessionStorage.setItem('roles', JSON.stringify(decoded.authorities));

          // Dispatch the success action
          return dispatch(receiveLogin(user));
        }
      })
      .catch(err => console.log('Error: ', err));
  };
}

export const CLIENT_REQUEST = 'CLIENT_REQUEST';
export const CLIENT_SUCCESS = 'CLIENT_SUCCESS';
export const CLIENT_FAILURE = 'CLIENT_FAILURE';

export function fetchClient(clientId) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/clients/${clientId}`,
      authenticated: true,
      types: [CLIENT_REQUEST, CLIENT_SUCCESS, CLIENT_FAILURE]
    }
  };
}


export const AFFILIATES_REQUEST = 'AFFILIATES_REQUEST';
export const AFFILIATES_SUCCESS = 'AFFILIATES_SUCCESS';
export const AFFILIATES_FAILURE = 'AFFILIATES_FAILURE';

export function fetchAffiliatesByPos(currentAffiliate) {

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/affiliates/view/byPosAllowed`,
      params: {
        statusList: ['enabled', 'pending']
      },
      authenticated: true,
      types: [AFFILIATES_REQUEST, AFFILIATES_SUCCESS, AFFILIATES_FAILURE],
      currentAffiliateId: currentAffiliate ? currentAffiliate : null
    }
  };
}

/* REPORTS */

export const REPORTS_REQUEST = 'REPORTS_REQUEST';
export const REPORTS_SUCCESS = 'REPORTS_SUCCESS';
export const REPORTS_FAILURE = 'REPORTS_FAILURE';

export function fetchDashboardReport(dashboardId, request) {
  const config = {
    method: 'POST',
    body: JSON.stringify(request)
  };

  return {
    [CALL_API]: {
      endpoint: `${UTILS_SERVICE_URL}/metabase/dashboards/${dashboardId}`,
      config,
      authenticated: true,
      types: [REPORTS_REQUEST, REPORTS_SUCCESS, REPORTS_FAILURE]
    }
  };
}

export function fetchDashboardReportDL(dashboardId, request) {
  const config = {
    method: 'POST',
    body: JSON.stringify(request)
  };

  return {
    [CALL_API]: {
      endpoint: `${UTILS_SERVICE_URL}/metabase/questions/${dashboardId}`,
      config,
      authenticated: true,
      types: [REPORTS_REQUEST, REPORTS_SUCCESS, REPORTS_FAILURE]
    }
  };
}

export const METABASE_SESSION_REQUEST = 'METABASE_SESSION_REQUEST';
export const METABASE_SESSION_SUCCESS = 'METABASE_SESSION_SUCCESS';
export const METABASE_SESSION_FAILURE = 'METABASE_SESSION_FAILURE';

export function fetchMetabaseSession() {
  const config = {
    method: 'POST'
  };

  return {
    [CALL_API]: {
      endpoint: `${UTILS_SERVICE_URL}/metabase/api/session`,
      config,
      authenticated: true,
      types: [
        METABASE_SESSION_REQUEST,
        METABASE_SESSION_SUCCESS,
        METABASE_SESSION_FAILURE
      ]
    }
  };
}

export const METABASE_CSV_REQUEST = 'METABASE_CSV_REQUEST';
export const METABASE_CSV_SUCCESS = 'METABASE_CSV_SUCCESS';
export const METABASE_CSV_FAILURE = 'METABASE_CSV_FAILURE';

export function fetchMetabaseCSV(request, cardId) {
  const config = {
    method: 'POST',
    headers: {
      'X-Metabase-session': sessionStorage.getItem('metabase-id')
    },
    body: JSON.stringify([request])
  };

  return {
    [CALL_API]: {
      endpoint: `${UTILS_SERVICE_URL}/metabase/api/card/${cardId}/query/csv`,
      config,
      authenticated: true,
      types: [METABASE_CSV_REQUEST, METABASE_CSV_SUCCESS, METABASE_CSV_FAILURE]
    }
  };
}


export function fetchLanguages(clientId) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/clients/${clientId}/languages`,
      authenticated: true,
      types: [LANGUAGE_REQUEST, LANGUAGE_SUCCESS, LANGUAGE_FAILURE]
    }
  };
}

export const POINT_OF_SALE_REQUEST = 'POINT_OF_SALE_REQUEST';
export const POINT_OF_SALE_SUCCESS = 'POINT_OF_SALE_SUCCESS';
export const POINT_OF_SALE_FAILURE = 'POINT_OF_SALE_FAILURE';

export function fetchPointOfSale() {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/pointOfSales`,
      authenticated: true,
      types: [
        POINT_OF_SALE_REQUEST,
        POINT_OF_SALE_SUCCESS,
        POINT_OF_SALE_FAILURE
      ]
    }
  };
}

export const AFFILIATE_REQUEST = 'AFFILIATES_REQUEST';
export const AFFILIATE_SUCCESS = 'AFFILIATES_SUCCESS';
export const AFFILIATE_FAILURE = 'AFFILIATES_FAILURE';

export function fetchAffiliate() {
	return {
		[CALL_API]: {
			endpoint: `${CATALOG_SERVICE_URL}/affiliates`,
			authenticated: true,
			types: [AFFILIATE_REQUEST, AFFILIATE_SUCCESS, AFFILIATE_FAILURE]
		}
	};
}

export function refreshUser(posId) {
  const refreshToken = localStorage.getItem('refresh_token');

  if (refreshToken) {
    let config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${clientAuthBase64}`
      },
      body: `grant_type=refresh_token&refresh_token=${refreshToken}`
    };

    return dispatch => {
      // We dispatch requestLogin to kickoff the call to the API
      dispatch(requestLogin());

      return fetch(AUTH_URL, config).then(response => {


        if ([401, 403].indexOf(response.status) !== -1) {
          return response;
        } else {
          return response
            .json()
            .then(user => ({ user, response }))
            .then(({ user, response }) => {
              return succesToken({ user, response, dispatch, posId });
            });
        }
      });
    };
  }
}

function succesToken({ user, response, dispatch, posId }) {

  if (!response.ok) {
    // If there was a problem, we want to
    // dispatch the error condition
    dispatch(loginError(user.message));
    return Promise.reject(user);
  } else {
    // If login was successful, set the token in local storage
    localStorage.setItem('id_token', user.jti);
    localStorage.setItem('access_token', user.access_token);
    localStorage.setItem('refresh_token', user.refresh_token);
    const decoded = jwt_decode(user.access_token);
    localStorage.setItem('posAllowed', JSON.stringify(decoded.posAllowed));

    if (posId) {
      localStorage.setItem('id_pos', posId);
    } else {
      posId = localStorage.getItem('id_pos');
    }
    // Dispatch the success action
    dispatch(receiveLogin(user, posId));
  }

  return response;
}

